var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666a70;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIDEO",
    transform: "translate(-337 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6258",
    "data-name": "Path 6258",
    className: "cls-1",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(337 24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10716",
    "data-name": "Group 10716",
    transform: "translate(-64 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18976",
    "data-name": "Rectangle 18976",
    className: "cls-2",
    transform: "translate(409 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 18
  })), /*#__PURE__*/React.createElement("path", {
    id: "Play_video",
    "data-name": "Play video",
    className: "cls-1",
    d: "M3275.461,151.249h-20.334a4.869,4.869,0,0,1-4.869-4.859V126.108a4.869,4.869,0,0,1,4.869-4.859h20.334a4.869,4.869,0,0,1,4.868,4.859v20.283A4.868,4.868,0,0,1,3275.461,151.249Zm-15.889-21.462a3.881,3.881,0,0,0-3.881,3.881V139.1a3.881,3.881,0,0,0,3.881,3.881h11.643a3.881,3.881,0,0,0,3.881-3.881v-5.433a3.881,3.881,0,0,0-3.881-3.881Zm3.881,2.329,6.916,4.225-6.916,4.225Z",
    transform: "translate(-2844.258 -90.249)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.e34652565bf2c499744c3aa57acd5e30.svg";
export { ForwardRef as ReactComponent };